import { all } from "redux-saga/effects";
import { AnyAction, Reducer, combineReducers } from "redux";
import * as auth from "../../app/modules/auth";
import tictactoe from "app/modules/cpltest/tictactoe/TicTacToeSlice";
import userProfileReducer from "app/modules/admin/userProfile/components/ProfileDetailsSlice";
import globalActivityIndicator from "app/modules/shared/globalActivityIndicator/GlobalActivityIndicatorSlice";
import licenceBanner from "app/system/licenceCheck/LicenceBannerSlice";
import standardDescriptionsReducer from "app/modules/shared/standardDescriptions/components/StandardDescriptionsSlice";
import errorAlertReducer from "app/system/errors/ServerErrorAlertSlice";
import developmentSelectReducer from "app/modules/shared/selectComponents/developmentSelect/components/DevelopmentSelectSlice";
import clientSelectReducer from "app/modules/shared/selectComponents/clientSelect/components/ClientSelectSlice";
import blockSelectReducer from "app/modules/shared/selectComponents/blockSelect/components/BlockSelectSlice";
import fundScheduleSelectReducer from "app/modules/shared/selectComponents/fundScheduleSelect/components/FundScheduleSelectSlice";
import fundScheduleChargeTypeSelectReducer from "app/modules/shared/selectComponents/fundScheduleChargeTypeSelect/components/FundScheduleChargeTypeSelectSlice";
import countrySelectReducer from "app/modules/shared/selectComponents/countrySelect/components/CountrySelectSlice";
import jobTypeSelectReducer from "app/modules/shared/selectComponents/jobTypeSelect/components/JobTypeSelectSlice";
import legalEntitySelectReducer from "app/modules/shared/selectComponents/legalEntitySelect/components/LegalEntitySelectSlice";
import purchaseAccountSelectReducer from "app/modules/shared/selectComponents/purchaseAccountSelect/components/PurchaseAccountSelectSlice";
import userSelectReducer from "app/modules/shared/selectComponents/userSelect/components/UserSelectSlice";
import subordinateSelectReducer from "app/modules/shared/selectComponents/subordinateSelect/components/SubordinateSelectSlice";
import maintenanceReducer from "app/system/maintenance/MaintenanceSlice";
import signalRAlertsReducer from "signalR/notifications/SignalRAlertSlice";
import signalRProgressReducer from "signalR/notifications/SignalRProgressBarSlice";
import documentSubTypesReducer from "app/modules/admin/customisableTypes/pages/DocumentSubTypes/DocumentSubTypesSlice";
import slaTypesReducer from "app/modules/admin/customisableTypes/pages/SLATypes/SLATypesSlice";
import userTaskTypeSelectReducer from "app/modules/shared/selectComponents/userTaskTypeSelect/components/UserTaskTypeSelectSlice";
import userTaskStatusTypeSelectReducer from "app/modules/shared/selectComponents/userTaskStatusTypeSelect/components/UserTaskStatusTypeSelectSlice";
import userTasksTableReducer from "app/modules/scheduling/userTasks/components/UserTasksTableSlice";
import userTaskReducer from "app/modules/scheduling/userTasks/components/UserTaskSlice";
import slaTypesSelectReducer from "app/modules/shared/selectComponents/slaTypeSelect/components/SLATypeSelectSlice";
import userGroupsSelectReducer from "app/modules/shared/selectComponents/userGroupSelect/components/UserGroupSelectSlice";
import workingHoursReducer from "app/modules/admin/workingHours/pages/StandardWorkingHours/StandardWorkingHoursSlice";
import overrideWorkingHoursReducer from "app/modules/admin/workingHours/pages/OverrideWorkingHours/OverrideWorkingHoursSlice";
import changeTrackingReducer from "app/modules/shared/changeTracking/components/ChangeTrackingSlice";
import cplCalendarReducer from "app/modules/scheduling/calendar/components/CPLCalendarSlice";
import workWeekViewReducer from "app/modules/scheduling/calendar/components/WorkWeekViewSlice";
import cpl2UserLoginReducer from "app/modules/auth/components/CPL2UserLoginSlice";
import caseTypesReducer from "app/modules/admin/customisableTypes/pages/CaseTypes/CaseTypesSlice";
import caseStatusTypesReducer from "app/modules/admin/customisableTypes/pages/CaseStatusTypes/CaseStatusTypesSlice";
import caseTypesSelectReducer from "app/modules/shared/selectComponents/caseTypeSelect/components/CaseTypeSelectSlice";
import caseStatusTypesSelectReducer from "app/modules/shared/selectComponents/caseStatusTypeSelect/components/CaseStatusTypeSelectSlice";
import casesTableReducer from "app/modules/cases/components/CasesTableSlice";
import meetingsTableReducer from "app/modules/scheduling/meetings/components/MeetingsTableSlice";
import meetingTypesReducer from "app/modules/admin/customisableTypes/pages/MeetingTypes/MeetingTypesSlice";
import caseReducer from "app/modules/cases/components/CaseFormSlice";
import meetingReducer from "app/modules/scheduling/meetings/components/MeetingFormSlice";
import meetingTypesSelectReducer from "app/modules/shared/selectComponents/meetingTypeSelect/components/MeetingTypeSelectSlice";
import commentThreadReducer from "app/modules/shared/commentThread/components/CommentThreadSlice";
import emailVerificationReducer from "app/modules/admin/userProfile/components/ValidateEmailSlice";
import passwordChangeReducer from "app/modules/admin/userProfile/components/PasswordChangeSlice";
import createConnectorsReducer from "app/modules/shared/cplCoreConnectors/createRecords/CreateConnectorSlice";
import clientPortalUsersTableReducer from "app/modules/clients/clientsPortalUsers/components/ClientPortalUsersTableSlice";
import clientPortalUserReducer from "app/modules/clients/clientsPortalUsers/components/ClientPortalUserFormSlice";
import dailyItineraryReducer from "app/pages/dashboard/components/DailyItinerarySlice";
import weeklyMeetingsReducer from "app/pages/dashboard/components/WeeklyMeetingsSlice";
import actionableCasesReducer from "app/pages/dashboard/components/ActionableCasesSlice";
import externalAccessReducer from "app/modules/shared/externalAccess/ExternalAccessSlice";
import jobsReducer from "app/modules/jobs/components/JobsTableSlice";
import jobReducer from "app/modules/jobs/components/JobFormSlice";
import jobStatusTypesSelectReducer from "app/modules/shared/selectComponents/jobStatusTypeSelect/components/JobStatusTypeSelectSlice";
import estimatesTableReducer from "app/modules/estimates/components/EstimatesTableSlice";
import estimateReducer from "app/modules/estimates/components/EstimateFormSlice";
import apiStatusReducer from "app/system/apiStatus/APIStatusSlice";
import termsAndConditionsReducer from "app/modules/admin/termsAndConditions/TermsAndConditionsSlice";
import taskActionsReducer from "app/modules/shared/TaskActions/TaskActionsSlice";
import userGroupsReducer from "app/modules/admin/userGroups/components/UserGroupSlice";
import userGroupMemberReducer from "app/modules/admin/userGroups/components/UserGroupMembersSlice";
import usersTableReducer from "app/modules/admin/userTable/components/UserTableSlice";
import companyBrandingReducer from "app/modules/admin/companyBranding/components/CompanyBrandingSlice";
import permissionAssignmentsReducer from "app/modules/admin/userPermissions/components/PermissionAssignmentsSlice";
import permissionCategoriesReducer from "app/modules/admin/userPermissions/components/PermissionCategoriesSlice";
import userMigrationReducer from "app/modules/admin/userTable/components/UsersMigrationSlice";
import paymentProvidersReducer from "app/modules/admin/paymentProviders/components/PaymentProvidersSlice";
import newUserProfileReducer from "app/modules/admin/userProfile/components/NewUserProfileSlice";
import directorFormReducer from "app/modules/directors/components/DirectorFormSlice";
import directorDetailsReducer from "app/modules/directors/components/DirectorDetailsSlice";
import userPermissionsreducer from "app/modules/admin/userProfile/components/UserPermissionsSlice";
import powerBIReportsReducer from "app/modules/powerbi/PowerBIReportsSlice";
import powerBIReportsSelectReducer from "app/modules/shared/selectComponents/powerBIReportSelect/components/PowerBIReportSelectSlice";
import backgroundActivityReducer from "app/modules/backgroundActivities/components/BackgroundActivitySlice";
import componentsTestPageReducer from "app/modules/cpltest/componentsTest/ComponentsTestPageSlice";
import sessionExpiredReducer from "app/system/sessionExpired/SessionExpiredSlice";
import AIAssistantReducer from "app/modules/aiAssistant/AIAssistantSlice";
import webNarrativesReducer from "app/modules/admin/webNarratives/components/WebNarrativesSlice";
import ClientPortalLoginReducer from "app/modules/admin/companyBranding/components/ClientPortalLoginSlice";
import directDebitCollectionDaysReducer from "app/modules/admin/directDebitCollectionDays/DirectDebitCollectionDaysSlice";
import errorHandlerReducer from "app/pages/errors/ErrorHandlerSlice";
import serviceChargeInvoicingReducer from "app/modules/serviceChargeInvoicing/components/ServiceChargeInvoicingSlice";
import serviceChargeDateCodesReducer from "app/modules/serviceChargeInvoicing/components/steps/ServiceChargeDateCodes/ServiceChargeDateCodesSlice";
import serviceChargeDevelopmentChargePreListReducer from "app/modules/serviceChargeInvoicing/components/steps/DevelopmentChargesPreList/DevelopmentChargesPreListSlice";
import propertyManagerSelectSlice from "app/modules/shared/selectComponents/propertyManagerSelect/components/PropertyManagerSelectSlice";
import serviceChargeInvoiceSettingsReducer from "app/modules/admin/cplSettings/components/ServiceChargeInvoiceSettings/components/ServiceChargeInvoiceSettingsSlice";
import directDebitAdminFeeReducer from "app/modules/admin/cplSettings/components/DirectDebitAdminFee/components/DirectDebitAdminFeeSlice";
import anticipatedExpenditureReducer from "app/modules/anticipatedExpenditure/components/AnticipatedExpenditureSlice";
import serviceChargeinvoicePreviewsReducer from "app/modules/serviceChargeInvoicing/components/steps/InvoicePreview/InvoicesPreviewSlice";
import serviceChargeInvoiceSendingReducer from "app/modules/serviceChargeInvoicing/components/steps/InvoiceSending/InvoiceSendingSlice";
import serviceChargeInvoicingSummariesReducer from "app/modules/serviceChargeInvoicing/components/ServiceChargeInvoicingSummariesSlice";
import fundHeaderSelectReducer from "app/modules/shared/selectComponents/fundHeaderSelect/components/FundHeaderSelectSlice";
import impersonationReducer from "app/modules/impersonation/components/ImpersonationSlice";
import dataImportActiveSubmissionReducer from "app/modules/dataImport/wizard/ActiveSubmissionSlice";
import dataImportSubmissionsListReducer from "app/modules/dataImport/landingPage/SubmissionsListSlice";
import dataImportUploadReducer from "app/modules/dataImport/wizard/steps/FileUpload/FileUploadSlice";
import dataImportTypesReducer from "app/modules/dataImport/wizard/ReferenceDataSlice";
import dataImportParsingReducer from "app/modules/dataImport/wizard/steps/Parsing/ParsingSlice";
import dataImportMappingReducer from "app/modules/dataImport/wizard/steps/Mapping/MappingSlice";
import dataImportValidationReducer from "app/modules/dataImport/wizard/steps/Validation/ValidationSlice";
import dataImportSubmissionLockReducer from "app/modules/dataImport/wizard/SubmissionLockSlice";
import directorsReducer from "app/modules/directors/components/DirectorsTableSlice";

const combinedReducer = combineReducers({
  auth: auth.reducer,
  tictactoe,
  userProfile: userProfileReducer,
  globalActivityIndicator,
  licenceBanner,
  developmentSelect: developmentSelectReducer,
  errorAlert: errorAlertReducer,
  standardDescriptions: standardDescriptionsReducer,
  fundScheduleSelect: fundScheduleSelectReducer,
  fundScheduleChargeTypeSelect: fundScheduleChargeTypeSelectReducer,
  blockSelect: blockSelectReducer,
  clientSelect: clientSelectReducer,
  jobTypeSelect: jobTypeSelectReducer,
  countrySelect: countrySelectReducer,
  legalEntitySelect: legalEntitySelectReducer,
  purchaseAccountSelect: purchaseAccountSelectReducer,
  userSelect: userSelectReducer,
  subordinateSelect: subordinateSelectReducer,
  maintenance: maintenanceReducer,
  signalRAlerts: signalRAlertsReducer,
  signalRProgress: signalRProgressReducer,
  documentSubTypes: documentSubTypesReducer,
  slaTypes: slaTypesReducer,
  userTaskTypeSelect: userTaskTypeSelectReducer,
  userTasks: userTasksTableReducer,
  userTask: userTaskReducer,
  userTaskStatusTypeSelect: userTaskStatusTypeSelectReducer,
  slaTypesSelect: slaTypesSelectReducer,
  userGroupsSelect: userGroupsSelectReducer,
  standardWorkingHours: workingHoursReducer,
  overrideWorkingHours: overrideWorkingHoursReducer,
  changeTracking: changeTrackingReducer,
  cpl2UserLogin: cpl2UserLoginReducer,
  cplCalendar: cplCalendarReducer,
  workWeekView: workWeekViewReducer,
  caseTypes: caseTypesReducer,
  caseStatusTypes: caseStatusTypesReducer,
  caseTypesSelect: caseTypesSelectReducer,
  caseStatusTypesSelect: caseStatusTypesSelectReducer,
  case: caseReducer,
  cases: casesTableReducer,
  meeting: meetingReducer,
  meetings: meetingsTableReducer,
  meetingTypes: meetingTypesReducer,
  meetingTypesSelect: meetingTypesSelectReducer,
  commentThread: commentThreadReducer,
  validateEmail: emailVerificationReducer,
  passwordChange: passwordChangeReducer,
  createConnectors: createConnectorsReducer,
  clientPortalUser: clientPortalUserReducer,
  clientPortalUsers: clientPortalUsersTableReducer,
  dailyItinerary: dailyItineraryReducer,
  weeklyMeetings: weeklyMeetingsReducer,
  actionableCases: actionableCasesReducer,
  externalAccess: externalAccessReducer,
  jobs: jobsReducer,
  job: jobReducer,
  jobStatusTypeSelect: jobStatusTypesSelectReducer,
  estimates: estimatesTableReducer,
  estimate: estimateReducer,
  apiStatus: apiStatusReducer,
  termsAndConditions: termsAndConditionsReducer,
  taskActions: taskActionsReducer,
  userGroups: userGroupsReducer,
  userGroupMembers: userGroupMemberReducer,
  userTable: usersTableReducer,
  companyBranding: companyBrandingReducer,
  permissionAssignments: permissionAssignmentsReducer,
  permissionCategories: permissionCategoriesReducer,
  userMigration: userMigrationReducer,
  paymentProviders: paymentProvidersReducer,
  newUserProfile: newUserProfileReducer,
  director: directorFormReducer,
  directorDetails: directorDetailsReducer,
  userPermissions: userPermissionsreducer,
  powerBIReports: powerBIReportsReducer,
  powerBIReportsSelect: powerBIReportsSelectReducer,
  backgroundActivities: backgroundActivityReducer,
  componentsTest: componentsTestPageReducer,
  sessionExpired: sessionExpiredReducer,
  AIAssistant: AIAssistantReducer,
  webNarratives: webNarrativesReducer,
  ClientPortalLogin: ClientPortalLoginReducer,
  directDebitCollectionDays: directDebitCollectionDaysReducer,
  errorHandler: errorHandlerReducer,
  serviceChargeInvoicing: serviceChargeInvoicingReducer,
  serviceChargeDateCodes: serviceChargeDateCodesReducer,
  propertyManagerSelect: propertyManagerSelectSlice,
  serviceChargeDevelopmentChargePreList: serviceChargeDevelopmentChargePreListReducer,
  serviceChargeInvoiceSettings: serviceChargeInvoiceSettingsReducer,
  directDebitAdminFee: directDebitAdminFeeReducer,
  anticipatedExpenditure: anticipatedExpenditureReducer,
  serviceChargeInvoicePreviews: serviceChargeinvoicePreviewsReducer,
  serviceChargeInvoiceSending: serviceChargeInvoiceSendingReducer,
  serviceChargeInvoiceSummaries: serviceChargeInvoicingSummariesReducer,
  fundHeaderSelect: fundHeaderSelectReducer,
  impersonation: impersonationReducer,
  dataImportActiveSubmission: dataImportActiveSubmissionReducer,
  dataImportSubmissionsList: dataImportSubmissionsListReducer,
  dataImportUpload: dataImportUploadReducer,
  dataImportTypes: dataImportTypesReducer,
  dataImportParsing: dataImportParsingReducer,
  dataImportMapping: dataImportMappingReducer,
  dataImportValidation: dataImportValidationReducer,
  dataImportSubmissionLock: dataImportSubmissionLockReducer,
  directors: directorsReducer,
});

export const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === auth.actionTypes.Logout) {
    // These are intentionally left in the state on logout
    // Auth state will be cleared by the auth reducer on logout
    state = { auth: state.auth } as RootState;
  }
  return combinedReducer(state, action);
};

export type RootState = ReturnType<typeof combinedReducer>;

export function* rootSaga() {
  yield all([auth.saga()]);
}
